export default __webpack_public_path__ + "freelancer-toolkit-cluster-logo-1.318a7d46.png";